export const API_URL = 'https://admin.wonulla.to/';

export default true;
